import { gql, useQuery } from '@apollo/client';
import { Checkbox, Skeleton } from '@perch-labs/shrike';
import { useEffect, useState } from 'react';
import { ErrorMessage } from '~/components/error-message';
import { Container } from '~/components/layout';
import { TermsText } from '~/components/terms/terms-text';
import { OnChange } from '~/components/validating-input';
import { EventName } from '~/utils/logger';

export const FETCH_WAITLIST_TERMS = gql`
  query Flex_FetchWaitListTerms {
    generalContractVersions(contractType: [privacy, terms, vnm], owner: Arcadia) {
      id
      displayName
    }
  }
`;

type WaitlistProps = {
  onChange: OnChange<number[]>;
};

export const WaitlistTerms = ({ onChange }: WaitlistProps) => {
  const { data, loading, error } = useQuery(FETCH_WAITLIST_TERMS);
  const [contracts, setContracts] = useState<any>([]);

  useEffect(() => {
    if (!loading) {
      setContracts(data?.generalContractVersions);
    }
  }, [loading, data]);

  const ids = contracts.map(contract => contract.id);
  const [isChecked, setIsChecked] = useState(false);

  const handleCheckBox = value => {
    setIsChecked(!!value);
    onChange(ids, { name: 'generalContractIds', isValid: !!ids.length && !!value });
  };

  if (error) {
    return (
      <ErrorMessage
        allow
        error="There was a problem loading our terms. Please refresh the page to try again."
      />
    );
  }
  if (loading) {
    return (
      <Container>
        <Skeleton backgroundColor="tertiary" width="100%" />
      </Container>
    );
  }
  return (
    <>
      <Checkbox checked={isChecked} onChange={handleCheckBox} data-testid="waitlist-terms-checkbox">
        {/* Only ever rendered on create-account. (SUBEXP-3193) */}
        <TermsText contracts={contracts} screen={EventName.UserScreen} />
      </Checkbox>
      <Container mt={6}>
        <ErrorMessage error={error} mb={3} />
      </Container>
    </>
  );
};
